import SearchResults from './SearchResults';

export default function SearchTestQuiz() {
  return <SearchResults categoryId={1} />;
}
